import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ProfileSheetPageEffects } from './profile-sheet-page.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ProfileSheetPageEffects])],
})
export class ProfileSheetPageStoreModule {}
